export default {
  id: 91,
  title: 'Target #91 - Reflection',
  url: 'https://cssbattle.dev/play/91',
  colors: ['#6CB3A9', '#D25B70', '#F6DF96'],
  solution:
    '<a a><a b><a c><style>[a],[c]{width:400}[c],body{background:#6cb3a9}body{margin:0}a{position:fixed}[a]{height:150;background:#d25b70}[b]{top:50;left:100;width:200;height:200;border-radius:9in;background:#f6df96}[c]{top:150;height:15;box-shadow:0 25px #6cb3a9,0 50px #6cb3a9,0 75px #6cb3a9}</style>',
}
